import { FormEvent, useState } from "react";
import { useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { resources } from "@constants/hardcoded-strings";
import { LOGIN_URL } from "@constants/routes";
import { ButtonTypes } from "@enums/button-types";
import { setSession } from "@redux/actions/session-actions";
import { getSessionRequest } from "@requests/axnadmin-core";
import { ButtonWithSpinner } from "@containers/common/button-with-spinner/button-with-spinner";
import { DefaultModal } from "@containers/common/modals/default-modal/default-modal";
import { getHostnameWithScheme } from "@utils/http-util";

type SessionTimeoutWarningModalProps = {
    onModalClose: () => void;
};

export const SessionTimeoutWarningModal = (props: SessionTimeoutWarningModalProps) => {
    const dispatch = useDispatch();
    const { onModalClose } = props;

    const [requestInProgress, setRequestInProgress] = useState(false);

    const handleSubmit = async (event: FormEvent) => {
        event.preventDefault();
        setRequestInProgress(true);
        const { data, error } = await getSessionRequest();
        if (data) {
            dispatch(setSession(data));
            setRequestInProgress(false);
            onModalClose();
        } else if (error) {
            const loginUrl = `${getHostnameWithScheme()}${LOGIN_URL}`;
            window.location.href = loginUrl;
        }
    };

    return (
        <DefaultModal
            automationId="session-timeout-warning-modal"
            ariaLabelledBy="session-timeout-warning-title"
            onHide={onModalClose}
            backdrop={"static"}
            keyboard={false}
            isMaxWidth={false}
        >
            <Form onSubmit={handleSubmit}>
                <Modal.Header id={"session-timeout-warning-title"} closeButton>
                    <Modal.Title>{resources.modals.sessionTimeoutWarning.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <p>{resources.modals.sessionTimeoutWarning.description}</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onModalClose}>{resources.common.buttons.close.label}</Button>
                    <ButtonWithSpinner
                        disabled={requestInProgress}
                        hideSpinner={false}
                        variant="primary"
                        type={ButtonTypes.SUBMIT}
                        label={resources.modals.sessionTimeoutWarning.buttons.keepMeLoggedIn.label}
                    />
                </Modal.Footer>
            </Form>
        </DefaultModal>
    );
};